var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCruiseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 44,
    viewBox: "0 0 42 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9999 40.1807L38.3907 30.7078C38.7379 29.738 38.3142 28.6578 37.4056 28.1962L21.8943 20.3174C21.3313 20.0314 20.6685 20.0314 20.1055 20.3174L4.59419 28.1962C3.68556 28.6578 3.26186 29.738 3.60903 30.7078L6.99987 40.1807",
    stroke: "#031B76",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 11.7361H10C8.8954 11.7361 8 12.6457 8 13.7678V25.9584L20.1619 20.2561C20.6937 20.0068 21.3063 20.0068 21.8381 20.2561L34 25.9584V13.7678C34 12.6457 33.1046 11.7361 32 11.7361Z",
    fill: "#BF0000",
    stroke: "#031B76",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 11.7361V3.60903C26 2.48692 25.1046 1.57727 24 1.57727H18C16.8954 1.57727 16 2.48692 16 3.60903V11.7361",
    stroke: "#031B76",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 30.022V38.149",
    stroke: "#031B76",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 42.2125C5 42.2125 5 40.1808 8 40.1808C11 40.1808 11 42.2125 14 42.2125C17 42.2125 17.5 40.1808 21 40.1808C24.5 40.1808 25 42.2125 28 42.2125C31 42.2125 31 40.1808 34 40.1808C37 40.1808 37 42.2125 41 42.2125",
    stroke: "#031B76",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCruiseIcon);
export default __webpack_public_path__ + "static/media/cruiseIcon.7828a77aa3cdc2107c50565591210d1f.svg";
export { ForwardRef as ReactComponent };